module.exports = __webpack_public_path__ + "img/tt.5388d304.png";